(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miniwe-home-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miniwe-photo-pairs')) {
  customElements.define('miniwe-photo-pairs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panels = [...this.querySelectorAll('[data-pair-id]')];
      this.choices = [...this.querySelectorAll('[data-pair-choice]')];
      this.choices.forEach((button, index) => {
        button.addEventListener('click', () => this.show(button.dataset.pairChoice), { signal });
        button.addEventListener('keydown', event => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.choices.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.choices.length) % this.choices.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.choices.length - 1;
          else return;
          event.preventDefault();
          const nextButton = this.choices[nextIndex];
          nextButton.focus(); this.show(nextButton.dataset.pairChoice);
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        if (this.panels.some(panel => panel.dataset.pairId === event.detail.blockId)) this.show(event.detail.blockId);
      }, { signal });
      if (this.choices.length) this.show(this.choices[0].dataset.pairChoice);
      this.setAttribute('data-ready', '');
    }
    show(id) {
      if (!this.panels.some(panel => panel.dataset.pairId === id)) return;
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.pairId !== id;
        if (!panel.hidden) panel.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      });
      this.choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pairChoice === id)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miniwe-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miniwe-hero-carousel')) {
  customElements.define('miniwe-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('.mw-hero-slide')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.toggle = this.querySelector('[data-play-toggle]');
      this.live = this.querySelector('.mw-hero-slides');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.active = 0;
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.timer = null;
      this.dots.forEach(button => button.addEventListener('click', () => { this.show(Number(button.dataset.slideTo)); this.schedule(); }, { signal }));
      this.toggle?.addEventListener('click', () => {
        this.paused = !this.paused;
        // An explicit Play click overrides the current control focus/hover.
        if (!this.paused) { this.focused = false; this.hovered = false; }
        this.updateControl(); this.schedule();
      }, { signal });
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
      this.addEventListener('touchstart', event => { this.touch = [event.touches[0].clientX, event.touches[0].clientY]; clearTimeout(this.timer); }, { passive: true, signal });
      this.addEventListener('touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch[0], dy = event.changedTouches[0].clientY - this.touch[1];
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.active + (dx < 0 ? 1 : -1));
        this.touch = null; this.schedule();
      }, { passive: true, signal });
      this.addEventListener('touchcancel', () => { this.touch = null; this.schedule(); }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', event => { if (event.matches) this.paused = true; this.updateControl(); this.schedule(); }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index); this.updateControl(); this.schedule(); }
      }, { signal });
      this.setAttribute('data-ready', '');
      this.show(0); this.updateControl(); this.schedule();
    }
    show(index) {
      if (!this.slides.length) return;
      this.active = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.active; if (i === this.active) { const image = slide.querySelector('.mw-hero-photo img'); if (image) image.loading = 'eager'; } });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.active)));
    }
    updateControl() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      const running = this.slides.length > 1 && !this.paused && !this.hovered && !this.focused && !document.hidden;
      if (this.live) this.live.setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.timer = setTimeout(() => { this.show(this.active + 1); this.schedule(); }, Math.max(3000, Number(this.dataset.interval) || 5500));
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.controller?.abort(); this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miniwe-home-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miniwe-showcase-carousel')) {
  customElements.define('miniwe-showcase-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.mw-showcase-track');
      this.controls = this.querySelector('.mw-showcase-controls');
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      if (!this.track || !this.previous || !this.next) return;
      const move = direction => {
        const firstCard = this.track.querySelector('.mw-showcase-card');
        if (!firstCard) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.track.addEventListener('scroll', () => this.updateEdges(), { passive: true, signal });
      window.addEventListener('resize', () => this.updateEdges(), { passive: true, signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.updateEdges());
        this.observer.observe(this.track);
      }
      this.setAttribute('data-ready', '');
      this.updateEdges();
    }
    updateEdges() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      this.controls.hidden = maximum <= 2;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miniwe-size-comparison')) {
  customElements.define('miniwe-size-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-size-target]');
        if (trigger && this.contains(trigger)) this.activate(trigger.dataset.sizeTarget);
      }, options);
      this.addEventListener('keydown', event => {
        const trigger = event.target.closest('[role="button"][data-size-target]');
        if (trigger && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          this.activate(trigger.dataset.sizeTarget);
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const detail = Array.from(this.querySelectorAll('[data-block-id]'))
          .find(item => item.dataset.blockId === event.detail.blockId);
        if (detail) this.activate(detail.id);
      }, options);
      this.activate(this.dataset.defaultTarget);
      this.setupPhone();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
    }
    /* 根据图表实际高度，按 iPhone 14 真实宽高比计算其宽度，保证图表与底部标签对齐 */
    setupPhone() {
      if (this.dataset.phoneEnabled !== 'true') return;
      const plot = this.querySelector('.szc-plot');
      if (!plot) return;
      const hPct = parseFloat(this.dataset.phoneHPct) || 73.35;
      const ratio = parseFloat(this.dataset.phoneRatio) || 0.487;
      const update = () => {
        const h = plot.clientHeight;
        if (!h) return;
        this.style.setProperty('--phone-w', (h * hPct / 100 * ratio).toFixed(1) + 'px');
      };
      this.onResize = update;
      update();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(plot);
      } else {
        window.addEventListener('resize', update);
      }
    }
    activate(target) {
      this.querySelectorAll('[data-size-target]').forEach(item => {
        const active = item.dataset.sizeTarget === target;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      this.querySelectorAll('[data-size-detail]').forEach(item => {
        const active = item.id === target;
        item.classList.toggle('is-active', active);
        item.hidden = !active;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
